import './index.scss';

export const flipbox = {
    bindEvents: function() {
        document.querySelectorAll('.js-flipbox-control').forEach((element) => {
            element.addEventListener('click', () => {
                document.querySelector('.flipbox').classList.toggle('flipbox--flipped');
            });
        });
    },
};
